import { Component, HostListener, Injector, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, SortEvent } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseClass } from 'src/app/views/utility/baseClass';

import { CountryService } from './country.service';
import { ExceldownloadComponent } from 'src/app/views/directives/exceldownload/exceldownload.component';
import Swal from 'sweetalert2';
import { GlobalMessage } from '../../utility/modals';
import { Utilityservice } from '../../utility/utilityservice.service';
import { CountrymodalComponent } from '../../directives/countrymodal/countrymodal.component';

@Component({
  selector: 'app-country',
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.css']
})
export class CountryComponent extends BaseClass implements OnInit {
  @ViewChild('dt') dt: any;
  public tableData: any[] = [];
  excel_paragraph='';
  public selectedItem: MenuItem | null = null;
  public commonScrollHeight = '';
  public searchText: string;
  public ref: DynamicDialogRef | undefined;
  public first2: number = 0;
  public rows2: number = 10;
  public totalRecords: number = 0;
  exceldownloadModal=false;
  public options = [];
  public paginatorArray = [];
  public visible: boolean = false;
  public position = 'top';
  public cols = [];
  public _selectedColumns = [];
  currentPageIndex: number = 0;
  rowsize: number = 10;
  tablecount: number = 0;
  message:GlobalMessage=new GlobalMessage();
  searchTerm: string = ''; 
  constructor(
    public router: Router,
    public dialogService: DialogService,
    public utilityservice :Utilityservice,
    private countryService: CountryService,
    public override injector: Injector // Make injector public here
  ) {
    super(injector);
    this.excel_paragraph=this.message.downloadexcel_text;
  }

  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
    this.getList();
    this.dynamiccols();
    this.utilityservice.getCSRFtoken();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  }

  dynamiccols() {
    this.cols = [
      { field: 'countryid', header: 'Country ID', type: 'Number', sort: true, filter: true, width: '2px !important', isChecked: true, class: 'headerid' },
      { field: 'countryname', header: 'Country Name', type: 'text', sort: true, filter: true, width: '2px !important', isChecked: true, class: 'otherheader' },
      { field: 'createdon', header: 'Created On', type: 'Date', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: 'activeflag', header: 'Status', type: 'text', sort: false, filter: false, width: '20px', isChecked: true, class: 'otherheader' }
    ];
    this._selectedColumns = this.cols;
  }

  // getList() {
  //   this.countryService.getCountryData().subscribe((data) => {
  //     this.tableData = data;
  //     this.options = this.utilityservice.getOptionDropdown(data.length);
  //     this.paginatorArray = this.options.map(e => e.value);
  //     this.totalRecords =this.tableData.length ;

  //   });
  // }

  getList() {
  const currentPageSize = this.rowsize;
 
  this.countryService.getCountryData().subscribe({
    next: (data: any) => {
      this.tableData = data;
      this.tableData = data.map(item => ({ ...item, isSelect: false }));
 
      this.options = this.utilityservice.getOptionDropdown(data.length);
      this.paginatorArray = this.options.map(e => e.value);
  
      if (!this.paginatorArray.includes(currentPageSize)) {
        this.paginatorArray.push(currentPageSize);
        this.paginatorArray.sort((a, b) => a - b);
      }
 
      this.rowsize = currentPageSize;
      this.totalRecords = this.tableData.length;
      this.tablecount = data.count ?? data.length;
  
      setTimeout(() => {
        if (this.dt) {
          this.dt.first = this.currentPageIndex;
        }
      }, 0);
    },
    error: (error) => {
      const timestamp = new Date().toLocaleString();
      Swal.fire({
        title: error.error?.error || "Error",
        text: `This error occurred at: ${timestamp}`,
        icon: "error",
      });
    }
  });
}

  showDialog() {
     let payload={}
     const width = this.utilityservice.isMobile() ? '90vw' : 'auto';
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
    width: width,
    height: '10rem',
    data: { excelname:"Country_Master_Data.xlsx",downloadapi:'common/country/countrydataexcel',method:'get',message:this.excel_paragraph,payload:payload },
    contentStyle: { overflow: 'hidden' },
    baseZIndex: 10000,
    });
    
  }

  closedpop() {
    this.visible = false;
  }

  show(title, data) {
    let details = {};
     this.currentPageIndex = this.dt?.first || 0;
    if (title === 'Modify Country') {
      this.countryService.getCountryById(data.countryid, Number).subscribe(res => {
        details = res;
        this.ref = this.dialogService.open(CountrymodalComponent, {
          header: title,
          width: '50vw',
          height: '40%',
          data: { title: title, datas: details },
          contentStyle: {},
          baseZIndex: 10000,
        });
        this.ref.onClose.subscribe(() => {
          this.getList();
        });
      });
    } else {
      details = {};
      this.ref = this.dialogService.open(CountrymodalComponent, {
        header: title,
        width: '50vw',
        height: '30%', 
        data: { title: title, datas: details },
        contentStyle: { overflow: '' },
        baseZIndex: 10000,
      });
      this.ref.onClose.subscribe(() => {
        this.getList();
      });
    }
  }

  handlePageChange(event: any) {
    this.rows2 = event.rows;
    this.currentPageIndex = event.first;
  }
  //Download Department Master Excel
  downloadgridexcel() {
    this.countryService.countryDataExcel().subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Country_Master_Data.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.exceldownloadModal=false;
    }, error => {
      Swal.fire('Something went wrong', '', 'error');

    })
      ;
  }
  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }

}
